import { render } from "./Training.vue?vue&type=template&id=f925eee0&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"

import "./Training.vue?vue&type=style&index=0&id=f925eee0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f925eee0"]])

export default __exports__